const stores = [
    {
      name: "Broadway",
      latitude: 29.43355761871724,
      longitude: -98.48118962916892,
      page: "/pages/grunt-style-broadway-retail-store"
    },
    {
      name: "Nebraska Crossing",
      latitude: 41.09926388914093,
      longitude: -96.24957633426573,
      page: "/pages/grunt-style-nebraska-crossing-store"
    },
    {
      name: "Sevierville",
      latitude: 35.83292273997845,
      longitude: -83.56788490206772,
      page: "/pages/grunt-style-sevierville-store"
    },
    {
      name: "Outlet Shoppes of Atlanta",
      latitude: 34.12092665370937,
      longitude: -84.52607263519818,
      page: "/pages/outlet-shoppes-at-atlanta-retail-store"
    },
    {
      name: "Outlet Shoppes of El Paso",
      latitude: 31.91364895255381,
      longitude: -106.58578048679864,
      page: "/pages/outlet-shoppes-at-el-paso-retail-store"
    },
    {
      name: "Branson Tanger Outlets",
      latitude: 36.64682082404315,
      longitude: -93.2629792,
      page: "/pages/branson-tanger-outlet-retail-store"
    },
    {
      name: "Tampa Premium Outlet",
      latitude: 28.18980852238171,
      longitude: -82.39134171349443,
      page: "/pages/tampa-premium-outlet-retail-store"
    },
    {
      name: "Phoenix Premium Outlets",
      latitude: 33.287153758856206,
      longitude: -111.9736099901982,
      page: "/pages/phoenix-premium-outlets-retail-store"
    },
    {
      name: "Opry Mills",
      latitude: 36.2053734519652,
      longitude: -86.69214358856603,
      page: "/pages/opry-mills-retail-store"
    },
    {
      name: "Savannah Tanger Outlets",
      latitude: 32.13488589561442,
      longitude: -81.24321567330043,
      page: "/pages/savannah-tanger-outlets-retail-store"
    },
    {
      name: "Destin Commons, FL",
      latitude: 30.390753929702512,
      longitude: -86.4248636,
      page: "/pages/destin-commons-retail-store",
    },
    {
      name: "Las Vegas South Premium Outlets",
      latitude: 36.0525604,
      longitude: -115.1687028,
      page: "/pages/las-vegas-south-premium-outlets-retail-store"
    },
    {
      name: "Myrtle Beach",
      latitude: 33.75108148371223,
      longitude: -78.95767185975104,
      page: "/pages/myrtle-beach-retail-store"
    },
    {
      name: "Tulsa Premium Outlet",
      latitude: 36.01342205686228,
      longitude: -95.96181287683565,
      page: "/pages/tulsa-premium-outlet-retail-store"
    },
    {
      name: "Norfolk Premium Outlet",
      latitude: 36.881270,
      longitude: -76.200629,
      page: "/pages/grunt-style-norfolk-retail-store"
    },
  ];